import React from "react";

import MyARViewer from "../../AR/test";

const Error404 = () => {
  return <MyARViewer />;
};

export default Error404;
